
/* 会员专享8大特权介绍 */
export const privilegeList = [
  '独家潮流内容',
  '时间轴每日更新',
  '商用授权保障',
  '高清无水印下载',
  '可商用范围广',
  'VIP极速下载',
  '线上电子发票',
  '专属服务1对1',
]


export const permission = [
  {
    label: '商用授权',
    iconClass: 'icon-a-1shang'
  },
  // {
  //   label: '内容下载',
  //   iconClass: 'icon-a-2img'
  // },
  {
    label: '下载限制',
    iconClass: 'icon-three'
  },
  {
    label: '版权保障',
    iconClass: 'icon-a-4copyright'
  },
  {
    label: '在线开票',
    iconClass: 'icon-a-3ticket'
  },
  {
    label: '商用授权',
    iconClass: 'icon-a-5media'
  },
  {
    label: '授权主体',
    iconClass: 'icon-com'
  },
  {
    label: '自定义收藏夹',
    iconClass: 'icon-shoucang'
  },
  {
    label: '定制化设计',
    iconClass: 'icon-dingzhi1'
  },
  {
    label: '团队共享收藏',
    iconClass: 'icon-tuandui'
  },
]
